/**
 * Overrides the native HTML5 autofocus attribute by allowing the behavior to trigger on angular view
 * instead of page load which only happens when the SPA loads.
 * @returns {{restrict: string, link(*, *): void}}
 */
export default function autofocusDirective() {
  return {
    restrict: 'A',
    link(scope, el) {
      el.focus();
    }
  };
}
